import _http from './http';
import _number from './number';
import _history from './history';

export * from './functools';
export const http = _http;
export const number = _number;
export const history = _history;
